import actions from './actions'
import getters from './getters'
import mutations from './mutations'
import ActivityModule from './activity'
import BehaviorModule from './behavior'
import StatisticsModule from './statistics'
import ProductsModule from './products'
import WalletModule from './wallet'
import NumbersModule from './numbers'
import NotificationsModule from './notifications'
import ContactsModule from './contacts'
import LocallyModule from './locally'
import TrackingModule from './tracking'
import TafModule from './taf'

let modules = {
  activity: ActivityModule,
  behavior: BehaviorModule,
  statistics: StatisticsModule,
  products: ProductsModule,
  wallet: WalletModule,
  numbers: NumbersModule,
  notifications: NotificationsModule,
  contacts: ContactsModule,
  locally: LocallyModule,
  tracking: TrackingModule,
  taf: TafModule
}

const getDefaultState = () => {
  return {
    id: null,
    email: null,
    firstName: null,
    lastName: null,
    fullName: null,
    initials: null,
    primaryNumber: null,
    currency: null,
    geolocation: null,
    timezone: null,
    profilePictureUrl: null,
    balance: null,
    balanceAmount: null,
    bonusMinutes: 0,
    vatNumber: null,
    locales: null,
    created: null,
    paymentCount: null,
    userServices: []
  }
}

const state = getDefaultState()

mutations.RESET_STATE = (state) => {
  Object.assign(state, getDefaultState())
}
actions.reset = ({ dispatch, commit }) => {
  dispatch('activity/reset')
  dispatch('behavior/reset')
  dispatch('statistics/reset')
  dispatch('products/reset')
  dispatch('wallet/reset')
  dispatch('numbers/reset')
  dispatch('notifications/reset')
  dispatch('contacts/reset')
  dispatch('tracking/reset')
  dispatch('taf/reset')

  commit('RESET_STATE')
}

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
  modules
}



// WEBPACK FOOTER //
// ./src/store/modules/user/index.js